import { BlockLoader } from './loading';

/** Full-height centered loading spinner.
 *
 * Extracted from the LMS editor pages (LmsContentEditor / LmsJourneyBuilder /
 * LmsModuleAssignments / LmsSessionForm), where this exact markup was duplicated.
 * Drawn with the loading kit's ring; the height (min-h-[400px]) is what it always was. */
export function PageLoader() {
  return <BlockLoader className="min-h-[400px]" />;
}
